<template>
  <div class="user-staff-code detail-item" v-if="editingData">

    <div class="head"><b>社員番号</b></div>
    <div class="data">
      <p>{{ editingData.staff_code ? editingData.staff_code : '-' }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
